import { CHAIN_INFO } from '../constants/chainInfo'

export function shortenAddress(address, charsLength = 4) {
  const prefixLength = 2 // "0x"
  if (!address) {
    return ''
  }
  if (address.length < charsLength * 2 + prefixLength) {
    return address
  }
  return (
    address.slice(0, charsLength + prefixLength) +
    '…' +
    address.slice(-charsLength)
  )
}

export function shortenHash(address, charsLength = 4) {
  const prefixLength = 0 // "0x"
  if (!address) {
    return ''
  }

  if (address?.length < charsLength * 2 + prefixLength) {
    return address
  }
  return (
    address.slice(0, charsLength + prefixLength) +
    '…' +
    address.slice(-charsLength)
  )
}

export function convertWeiToGwei(wei) {
  if (!wei) return 0
  const gwei = wei / 1000000000
  return gwei
}

export function getEtherscanLink(chainId, data, type) {
  // If it's Solana, use Solscan
  if (chainId === 'solana') {
    return getSolscanLink(data, type)
  }
  
  const prefix = `${CHAIN_INFO[chainId]?.explorer || CHAIN_INFO[1]?.explorer}`

  switch (type) {
    case 'transaction': {
      return `${prefix}tx/${data}`
    }
    case 'token': {
      return `${prefix}token/${data}`
    }
    case 'address':
    default: {
      return `${prefix}address/${data}`
    }

  }
}

export function getSolscanLink(data, type) {
  const prefix = 'https://solscan.io'

  switch (type) {
    case 'transaction': {
      return `${prefix}/tx/${data}`
    }
    case 'token': {
      return `${prefix}/token/${data}`
    }
    case 'account':
    case 'address':
    default: {
      return `${prefix}/account/${data}`
    }
  }
}

export function isAddress(address) {
  if (!/^(0x)?[0-9a-f]{40}$/i.test(address)) {
    return false
  }

  return true
}

export function compareAddresses(address1, address2) {
  if (!address1 || !address2) {
    console.error('compareAddresses: Both addresses must be provided')
  }

  const normalizedAddress1 = address1.toLowerCase()
  const normalizedAddress2 = address2.toLowerCase()

  return normalizedAddress1 === normalizedAddress2
}
